import { NgFor, NgIf } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import {
  cardFlag,
  CreditCardItemComponent,
} from '../credit-card-item/credit-card-item.component';
import { GetCardsData } from '../../../core/models/card.model';
import { LoadingComponent } from '../loading/loading.component';
import { I18nPipe } from '../../pipes/i18n.pipe';

interface cardInfo {
  token: string;
  id: number;
  cardFlag: cardFlag;
  lastFourDigits: string;
}

@Component({
  selector: 'umkt-credit-card-list',
  standalone: true,
  imports: [NgFor, CreditCardItemComponent, LoadingComponent, NgIf, I18nPipe],
  templateUrl: './credit-card-list.component.html',
  styleUrl: './credit-card-list.component.scss',
})
export class CreditCardListComponent implements OnInit, OnChanges {
  @Input()
  public cardsInfo: GetCardsData[] = [];

  @Input()
  public isLoading = false;

  public cardItems: cardInfo[] = [];
  public selectedCardId?: string | 'new';

  @Input() selectedCardToken: any | null = null;
  
  private readonly cardFlagsAllowed: cardFlag[] = [
    'VISA',
    'MASTERCARD',
    'AMEX',
    'UNKNOWN',
  ];

  @Output() cardSelected = new EventEmitter<string | 'new'>();

  ngOnInit(): void {
    this.mapCards();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['cardsInfo']) {
      this.mapCards();
    }
  }

  private isValidCardFlag(flag: string): flag is cardFlag {
    return this.cardFlagsAllowed.includes(flag as cardFlag);
  }

  private mapCards(): void {
    this.cardItems = this.cardsInfo.map(x => {
      const validFlag = this.isValidCardFlag(x.cardFlag)
        ? x.cardFlag
        : 'UNKNOWN';
      return {
        id: x.id,
        cardFlag: validFlag,
        lastFourDigits: x.lastFourDigits,
        token: x.cardToken
      };
    });
  }

  onCardSelected(selectedValue?: string | 'new'): void {
    this.selectedCardId = selectedValue;

    this.cardSelected.emit(this.selectedCardId);
  }
}
